export default "__VITE_ASSET__Beag9Gmu__"